import { create } from "zustand";

export enum ReactionActionState {
    IDLE,
    LOADING,
}

export const SWITCHING_STATE_TO_IDLE_TIME = 300;
interface ReactionActionSlice {
    reactionActionState: ReactionActionState;
    setReactionActionState: (value: ReactionActionState) => void;
}

export const useReactionActionStore = create<ReactionActionSlice>()((set) => ({
    reactionActionState: ReactionActionState.IDLE,
    setReactionActionState: (newValue: ReactionActionState) =>
        set(() => ({ reactionActionState: newValue })),
}));
